"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ApplyTemplateLibraryEntryResponse () {
        return ApplyTemplateLibraryEntryResponse;
    },
    get ListTemplateLibraryEntriesResponse () {
        return ListTemplateLibraryEntriesResponse;
    },
    get TemplateLibraryEntryDetail () {
        return TemplateLibraryEntryDetail;
    },
    get TemplateLibraryEntrySummary () {
        return TemplateLibraryEntrySummary;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _request = require("./request");
const TemplateLibraryEntrySummary = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    type: _request.TemplateLibraryEntryTypeEnum,
    name: _zod.z.string(),
    description: _zod.z.string(),
    tags: _zod.z.array(_zod.z.string()),
    updated_at: _utilsisomorphic.transformDate
});
const ListTemplateLibraryEntriesResponse = _zod.z.array(TemplateLibraryEntrySummary);
const TemplateLibraryEntryDetail = TemplateLibraryEntrySummary.extend({
    created_at: _utilsisomorphic.transformDate,
    version: _zod.z.number().int(),
    payload: _zod.z.unknown()
});
const ApplyTemplateLibraryEntryBase = _zod.z.object({
    appliedAt: _utilsisomorphic.transformDate
});
const ApplyTemplateLibraryEntryResponse = _zod.z.discriminatedUnion("type", [
    ApplyTemplateLibraryEntryBase.extend({
        type: _zod.z.literal("review_workflow"),
        workflowId: _utilsisomorphic.transformObjectId,
        formIds: _zod.z.array(_utilsisomorphic.transformObjectId),
        questionIds: _zod.z.array(_utilsisomorphic.transformObjectId)
    }),
    ApplyTemplateLibraryEntryBase.extend({
        type: _zod.z.literal("review_form"),
        formId: _utilsisomorphic.transformObjectId,
        questionIds: _zod.z.array(_utilsisomorphic.transformObjectId)
    }),
    ApplyTemplateLibraryEntryBase.extend({
        type: _zod.z.literal("survey"),
        surveyId: _utilsisomorphic.transformObjectId
    }),
    ApplyTemplateLibraryEntryBase.extend({
        type: _zod.z.literal("pdf_guide"),
        s3FileId: _utilsisomorphic.transformObjectId
    })
]);
